export default __webpack_public_path__ + "static/dance640-7bdbe0c10bd9d35f01171b6172313a86.gif";